import axios from "./axiosinstance";

const EmailApi = {
  send: (formData) =>
    axios.post("emails/send", formData), 
};

export default EmailApi;